import React, { useState } from 'react';
import { Box, Typography, Button, TextField, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, 
  TableRow, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,Fab, Popover,
  Grid, FormControl, Select, InputLabel, MenuItem, TablePagination, Snackbar, Alert, Tooltip, useTheme, useMediaQuery,Skeleton
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  EditRounded as EditIcon,
  DeleteRounded as DeleteIcon,
  WhatsApp as WhatsAppIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import api from '../api';
import EditButton from '../customcomponents/CustomEditButton';
import DeleteButton from '../customcomponents/CustomDeleteButton'; 
import SearchInput from '../customcomponents/CustomSearchInput';

function ProMasterPage() {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [createDialog, setCreateDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [editingPRO, setEditingPRO] = useState(null);
  const [newPRO, setNewPRO] = useState({ name: '', phone: '', email: '', firstPro: '', currentPro: '' });
  const [editPRO, setEditPRO] = useState({ name: '', phone: '', email: '', firstPro: ''  });
  const [errors, setErrors] = useState({ phone: '', email: '' });
  const [pros, setPROs] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [editErrors, setEditErrors] = useState({ phone: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [proToDelete, setProToDelete] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const isSmallScreen = useMediaQuery('(max-width:800px)');

  // Filter and paginate
  const filteredPROs = pros.filter(pro =>
    pro.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    pro.phone.includes(searchQuery) ||
    pro.email.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const paginatedPROs = filteredPROs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Phone input handler to allow only digits and max 10 digits
  const handleEditPhoneInput = (e) => {
  const value = e.target.value.replace(/\D/g, '').slice(0, 10);
  setEditPRO(prev => ({ ...prev, phone: value }));
};

  const handleCreatePhoneInput = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setNewPRO(prev => ({ ...prev, phone: value }));
  };

  const handleSearchClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose=(e)=>{
    setAnchorEl(null);
    // setSearchQuery('');
  }

  const validate = () => {
    let phoneError = '';
    let emailError = '';
    if (!/^\d{10}$/.test(newPRO.phone)) {
      phoneError = 'Phone number must be exactly 10 digits';
    }
    if (newPRO.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newPRO.email)) {
      emailError = 'Invalid email format (e.g., test@gmail.com)';
    }
    setErrors({ phone: phoneError, email: emailError });
    return !phoneError && !emailError;
  };

  const handleCreatePRO = async () => {
    if (!validate()) return;
    try {
      const payload = {
        name: newPRO.name,
        phoneNumber: newPRO.phone,
        email: newPRO.email,
        firstPro: newPRO.firstPro || null,
      };

      const res = await api.post('/pro-masters', payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'PRO created successfully', severity: 'success' });
        setCreateDialog(false);
        setNewPRO({ name: '', phone: '', email: '', firstPro: '', currentPro: '' });
        setErrors({ phone: '', email: '' });
        // Refresh the list
        const listRes = await api.get('/pro-masters');
        if (listRes.data && listRes.data.success && Array.isArray(listRes.data.data)) {
          setPROs(listRes.data.data.map(item => ({
            id: item._id,
            name: item.name || '-',
            phone: item.phoneNumber || '-',
            email: item.email || '-',
            firstPro: item.firstPro?.name || '-',
            firstProId: item.firstPro?._id || '',
            createdOn: item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
          })));
        }
      } else {
        setSnackbar({ open: true, message: 'Failed to create PRO', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to create PRO', severity: 'error' });
    }
  };

  const handleEdit = (pro) => {
    setEditingPRO(pro);

    setEditPRO({
      name: pro.name,
      phone: pro.phone,
      email: pro.email,
      firstPro: pro.firstProId || '',
    });
    setEditDialog(true);
  };

  const validateEdit = () => {
    let phoneError = '';
    let emailError = '';
    if (!/^\d{10}$/.test(editPRO.phone)) {
      phoneError = 'Phone number must be exactly 10 digits';
    }
    if (editPRO.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editPRO.email)) {
      emailError = 'Invalid email format (e.g., test@gmail.com)';
    }
    setEditErrors({ phone: phoneError, email: emailError });
    return !phoneError && !emailError;
  };

  const handleUpdatePRO = async () => {
    if (!validateEdit()) return;
    try {
      const payload = {
        name: editPRO.name,
        phoneNumber: editPRO.phone,
        email: editPRO.email,
        firstPro: editPRO.firstPro || null,
        // currentPro removed from edit logic
      };
      
      const res = await api.put(`/pro-masters/${editingPRO.id}`, payload);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'PRO updated successfully', severity: 'success' });
        setEditDialog(false);
        setEditingPRO(null);
        setEditPRO({ name: '', phone: '', email: '', firstPro: '', currentPro: '' });
        setEditErrors({ phone: '', email: '' });
        // Refresh the list
        const listRes = await api.get('/pro-masters');
        if (listRes.data && listRes.data.success && Array.isArray(listRes.data.data)) {
          setPROs(listRes.data.data.map(item => ({
            id: item._id,
            name: item.name || '-',
            phone: item.phoneNumber || '-',
            email: item.email || '-',
            firstPro: item.firstPro?.name || '-',
            firstProId: item.firstPro?._id || '',
            // currentPro removed from table data
            createdOn: item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
          })));
        }
      } else {
        setSnackbar({ open: true, message: 'Failed to update PRO', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to update PRO', severity: 'error' });
    }
  };

  const handleDeleteClick = (pro) => {
    setProToDelete(pro);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!proToDelete) return;
    try {
      const res = await api.delete(`/pro-masters/${proToDelete.id}`);
      if (res.data && res.data.success) {
        setSnackbar({ open: true, message: 'PRO deleted successfully', severity: 'success' });
        // Refresh the list
        const listRes = await api.get('/pro-masters');
        if (listRes.data && listRes.data.success && Array.isArray(listRes.data.data)) {
          setPROs(listRes.data.data.map(item => ({
            id: item._id,
            name: item.name || '-',
            phone: item.phoneNumber || '-',
            email: item.email || '-',
            firstPro: item.firstPro?.name || '-',
            firstProId: item.firstPro?._id || '',
            currentPro: item.currentPro || '-',
            createdOn: item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
          })));
        }
      } else {
        setSnackbar({ open: true, message: res.data?.message || 'Failed to delete PRO', severity: 'error' });
      }
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to delete PRO', severity: 'error' });
    } finally {
      setDeleteDialogOpen(false);
      setProToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setProToDelete(null);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  React.useEffect(() => {
    const fetchPROs = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get('/pro-masters');
        
        if (res.data && res.data.success && Array.isArray(res.data.data)) {
          setPROs(res.data.data.map(item => ({
            id: item._id,
            name: item.name || '-',
            phone: item.phoneNumber || '-',
            email: item.email || '-',
            firstPro: item.firstPro && typeof item.firstPro === 'object' ? item.firstPro.name || '-' : '-',
            firstProId: item.firstPro && typeof item.firstPro === 'object' ? item.firstPro._id || '' : '',
            currentPro: item.currentPro || '-',
            createdOn: item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
          })));
        } else {
          setPROs([]);
        }
      } catch (err) {
        setError('Failed to fetch PROs');
        setPROs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPROs();
  }, []);

  // Add proper reset when dialogs close
const handleCreateDialogClose = () => {
  setCreateDialog(false);
  setNewPRO({ name: '', phone: '', email: '', firstPro: '' });
  setErrors({ phone: '', email: '' });
};

const handleEditDialogClose = () => {
  setEditDialog(false);
  setEditingPRO(null);
  setEditPRO({ name: '', phone: '', email: '', firstPro: '' });
  setEditErrors({ phone: '', email: '' });
};

  // Add static options for First PRO dropdown
  // Remove static FIRST_PRO_OPTIONS, use pros state for dropdown options
  if(loading && isSmallScreen){
    return (
      <>
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>PRO Master</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>PRO Master</Typography>
          )
        }
        {/* <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'uppercase', color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary, mb: { xs: 2, md: 0 } }}>PRO Master</Typography> */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>
          {!isSmallScreen && (<SearchInput value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />)}
          {isSmallScreen ? (
            <>
            <IconButton
              onClick={handleSearchClick}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
              //   height: 40, width: 40,
              // }}
            >
              <SearchIcon />
            </IconButton>
            <IconButton
              onClick={() => setCreateDialog(true)}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
              // }}
            >
              <AddIcon />
            </IconButton>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={() => setCreateDialog(true)}
              startIcon={<AddIcon />}
              sx={{
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 700, borderRadius: 2, boxShadow: 1, fontSize: 15, px: 3, height: 40, textTransform: 'none',
                '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,},
              }}
            >
              Add PRO
            </Button>
          )}
        </Box>
        <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
          transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
          PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
        >
          <SearchInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  autoFocus />  
        </Popover>  
      </Paper>
          <Grid container spacing={1}>
            {Array.from(new Array(5)).map((_, index) => (
              <Grid item xs={12} key={index}>
                <Paper
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 1,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    background: 'background.paper', m:1,mt:0
                  }}
                >
                  {/* SL No. */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                      mb: 1,
                    }}
                  >
                    <Skeleton variant="text" width={40} height={24} />
                  </Box>

                  {/* Card content fields */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {['Name', 'Phone Number', 'Email', 'First PRO'].map((field, idx) => (
                      <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Skeleton variant="text" width={80} height={20} />
                        <Skeleton variant="text" width={120} height={20} />
                      </Box>
                    ))}
                  </Box>

                  {/* Actions */}
                  <Box display="flex" justifyContent="center" gap={1} mt={1}>
                    <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </>
      );
  }

  return (
    <Box sx={{ background: theme.palette.background.default }}>
      {/* Header */}
      <Paper elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}>
        {
          isSmallScreen ? (
            <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>PRO Master</Typography>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>PRO Master</Typography>
          )
        }
        {/* <Typography variant="h6" sx={{ fontWeight: 700, flex: 1, textTransform: 'uppercase', color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary, mb: { xs: 2, md: 0 } }}>PRO Master</Typography> */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,flexDirection: { xs: 'row', sm: 'row' } }}>
          {!isSmallScreen && (<SearchInput value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />)}
          {isSmallScreen ? (
            <>
            <IconButton
              onClick={handleSearchClick}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
              //   height: 40, width: 40,
              // }}
            >
              <SearchIcon />
            </IconButton>
            <IconButton
              onClick={() => setCreateDialog(true)}
              color='primary'
              // sx={{
              //   bgcolor: theme.palette.primary.main,
              //   color: theme.palette.primary.contrastText,
              //   borderRadius: 2, boxShadow: 1, height: 40, width: 40,
              //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,}, 
              // }}
            >
              <AddIcon />
            </IconButton>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={() => setCreateDialog(true)}
              startIcon={<AddIcon />}
              sx={{
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 700, borderRadius: 2, boxShadow: 1, fontSize: 15, px: 3, height: 40, textTransform: 'none',
                '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2,},
              }}
            >
              Add PRO
            </Button>
          )}
        </Box>
        <Popover open={open} anchorEl={anchorEl} onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
          transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
          PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
        >
          <SearchInput value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  autoFocus />  
        </Popover>  
      </Paper>

      {/* {isSmallScreen && showSearch && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 80,
            right: 16,
            backgroundColor: theme.palette.background.paper,
            boxShadow: '0px 2px 10px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 1,
            width: '85%',
            maxWidth: 300,
            zIndex: 1200,
          }}
        >
          <SearchInput
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            autoFocus
          />
        </Box>
      )}

      {isSmallScreen && (
        <Fab
          color="primary"
          aria-label="search"
          onClick={() => setShowSearch(prev => !prev)}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            boxShadow: 4,
            zIndex: 1300,
          }}
        >
          {showSearch ? <CloseIcon /> : <SearchIcon />}
        </Fab>
      )} */}
      
      {
        isSmallScreen ? ( 
           <>
           <Grid container spacing={1}>
              {filteredPROs.map((pro, index) => (
                <Grid item xs={12} key={pro.id}>
                  <Paper
                    elevation={2}
                    sx={{
                      borderRadius: 3,
                      p: 2,
                      mb: 1,
                      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                      background: theme.palette.background.paper,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.5, m:1,mt:0
                    }}
                  >
                    {/* SL No. at the top */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: 'background.textsecondary',
                          fontSize: '1.1rem',
                          letterSpacing: 1,
                        }}
                      >
                        # {page * rowsPerPage + index + 1}
                      </Typography>
                    </Box>
                    {/* Card content: field name left, value right */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.background.text, fontSize:12 }}>
                          Name
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.background.text, fontWeight: 500, fontSize:12 }}>
                          {pro.name}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.background.text, fontSize:12 }}>
                          Phone Number
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.background.text, fontWeight: 500, fontSize:12 }}>
                          {pro.phone}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.background.text, fontSize:12 }}>
                          Email
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.background.text, fontWeight: 500, fontSize:12 }}>
                          {pro.email}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.background.text, fontSize:12 }}>
                          First PRO
                        </Typography>
                        <Typography variant="body2" sx={{ color: theme.palette.background.text, fontWeight: 500, fontSize:12 }}>
                          {pro.firstPro || '-'}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Actions */}
                    <Box display={'flex'} justifyContent={'center'} >
                      <Button size="small" color="error" startIcon={<DeleteIcon />} onClick={() => handleDeleteClick(pro)}>
                        Delete
                      </Button>
                      <Button size="small" startIcon={<EditIcon />} onClick={() => handleEdit(pro)}>
                        Edit
                      </Button>
                    </Box>
                  </Paper>
                </Grid>
              ))}
           </Grid>
           </>
        ) : (
          <Paper elevation={1} sx={{
            borderRadius: 3,
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            p: 0,
            overflow: 'auto',
            background: theme.palette.background.paper,
            mb: 3,
          }}>
            {loading ? (
              <TableContainer sx={{ maxHeight: 540 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {['SL No.', 'Name', 'Phone Number', 'Email', 'First PRO', 'Actions'].map((header, idx) => (
                        <TableCell key={idx}
                          sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: 'white', textAlign: idx === 5 ? 'center' : 'left', }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Array.from(new Array(10)).map((_, index) => (
                      <TableRow key={index} sx={{ '&:hover': { backgroundColor: 'action.hover' }, transition: 'background 0.2s' }}>
                        <TableCell>
                          <Skeleton variant="text" width={20} />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="80%" />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="70%" />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="90%" />
                        </TableCell>
                        <TableCell>
                          <Skeleton variant="text" width="60%" />
                        </TableCell>
                        <TableCell>
                          <Box display="flex" justifyContent="space-evenly">
                            <Skeleton variant="circular" width={36} height={36} />
                            <Skeleton variant="circular" width={36} height={36} />
                            <Skeleton variant="circular" width={36} height={36} />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              ) : error ? (
                <Box sx={{ p: 4, textAlign: 'center', color: 'red' }}><Typography>{error}</Typography></Box>
              ) : (
              <TableContainer sx={{ maxHeight: 540 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>SL No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Name</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Phone Number</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>Email</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>First PRO</TableCell>
                      {/* Current PRO column removed */}
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText,textAlign:'center' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedPROs.map((pro, index) => (
                      <TableRow
                        key={pro.id}
                        sx={{ transition: 'background 0.2s', cursor: 'pointer', '&:hover': { backgroundColor: theme.palette.action.hover } }}
                      >
                        <TableCell sx={{ color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell sx={{ color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>{pro.name}</TableCell>
                        <TableCell sx={{ color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>{pro.phone}</TableCell>
                        <TableCell sx={{ color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>{pro.email}</TableCell>
                        <TableCell sx={{ color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>{pro.firstPro || '-'}</TableCell>
                        {/* Current PRO cell removed */}
                        <TableCell>
                          <Box display="flex" justifyContent={'space-evenly'}>
                            <EditButton onClick={() => handleEdit(pro)} />
                            <DeleteButton onClick={() => handleDeleteClick(pro)} />
                              
                            {/* <Tooltip title="Send Reference Message">
                              <IconButton
                                color="primary"
                                onClick={() => alert(`Send reference message to ${pro.name}`)}
                                sx={{
                                  borderRadius: '50%',
                                  boxShadow: theme.shadows[2],
                                  background: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.action.selected,
                                  transition: 'box-shadow 0.25s, background 0.25s, transform 0.25s',
                                  color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.info.main,
                                  width: 44,
                                  height: 44,
                                  p: 0,
                                  '&:hover': {
                                    background: theme.palette.info.main,
                                    color: theme.palette.info.contrastText,
                                    boxShadow: theme.shadows[6],
                                    transform: 'scale(1.15)'
                                  }
                                }}
                                size="large"
                              >
                                <WhatsAppIcon sx={{ fontSize: 26 }} />
                              </IconButton>
                            </Tooltip> */}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <Box sx={{ px: 2, py: 1, background: theme.palette.mode === 'dark' ? 'transparent':'#fff', borderRadius: '0 0 16px 16px' }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredPROs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) => `${from}–${to} of ${count}`}
                sx={{ border: 0, background: theme.palette.mode === 'dark' ? 'transparent':'#fff', p: 0, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}
              />
            </Box>
          </Paper>
        )
      }
      {/* Create PRO Dialog */}
      <Dialog open={createDialog} onClose={handleCreateDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>Create New PRO</DialogTitle>
        <DialogContent sx={{ bgcolor: theme.palette.background.paper }}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="PRO Name"
                value={newPRO.name}
                onChange={(e) => setNewPRO({ ...newPRO, name: e.target.value })}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                value={newPRO.phone}
                onChange={handleCreatePhoneInput}
                error={!!errors.phone}
                helperText={errors.phone}
                inputProps={{ maxLength: 10 }}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={newPRO.email}
                onChange={(e) => setNewPRO({ ...newPRO, email: e.target.value })}
                error={!!errors.email}
                helperText={errors.email}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="first-pro-label-create" sx={{color:'background.text'}}>First PRO</InputLabel>
                <Select
                  labelId="first-pro-label-create"
                  value={newPRO.firstPro}
                  label="First PRO"
                  onChange={e => setNewPRO({ ...newPRO, firstPro: e.target.value })}
                  sx={{ color: 'background.text' }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        color: 'background.text',
                      }
                    }
                  }}
                >
                  {pros.map(option => (
                    <MenuItem key={option.id} value={option.id} sx={{color:'background.text'}}>{option.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Current PRO field removed from create modal */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => handleCreateDialogClose()}
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleCreatePRO} 
            variant="contained" 
            sx={{ 
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: 2
              }
            }}
            setErrors={!!errors.phone || !!errors.email}
          >
            Create PRO
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit PRO Dialog */}
      <Dialog open={editDialog} onClose={handleEditDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>Edit PRO</DialogTitle>
        <DialogContent  >
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="PRO Name"
                value={editPRO.name}
                onChange={(e) => setEditPRO({ ...editPRO, name: e.target.value })}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                value={editPRO.phone}
                onChange={e => handleEditPhoneInput(e, true)}
                error={!!editErrors.phone}
                helperText={editErrors.phone}
                inputProps={{ maxLength: 10 }}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={editPRO.email}
                onChange={(e) => setEditPRO({ ...editPRO, email: e.target.value })}
                error={!!editErrors.email}
                helperText={editErrors.email}
                InputProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
                InputLabelProps={{ style: { color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary } }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="first-pro-label-edit"sx={{color:'background.text'}}>First PRO</InputLabel>
                <Select
                  labelId="first-pro-label-edit"
                  value={editPRO.firstPro }
                  label="First PRO"
                  onChange={e => setEditPRO({ ...editPRO, firstPro: e.target.value })}
                  sx={{ color: 'background.text' }} // Applies to the Select's input text
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        color: 'background.text', // Optional: apply to dropdown
                      }
                    }
                  }}
                >
                  {pros.map(option => (
                    <MenuItem key={option.id} value={option.id} sx={{ color: 'background.text' }} > {option.name} </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Current PRO field removed from edit modal */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleEditDialogClose}
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)'
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleUpdatePRO} 
            variant="contained" 
            sx={{ 
              bgcolor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              fontWeight: 600,
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: 2
              }
            }}
            setEditErrors={!!editErrors.phone || !!editErrors.email}
          >
            Update PRO
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>Delete PRO</DialogTitle>
        <DialogContent sx={{ bgcolor: 'transparent' }}>
          <Typography sx={{color:'background.text'}}>Are you sure you want to delete <b>{proToDelete?.name}</b>?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} sx={{ fontWeight: 600 }}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" sx={{ fontWeight: 600 }}>Delete</Button>
        </DialogActions>
      </Dialog>


      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default ProMasterPage; 